import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { AppTextService } from '@fi-shared/app-text';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiTaskHelperService } from '@fi-shared/fi-task-shared/fi-task-helper.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiTaskType } from '@fi-app/task-v2/fi-task-v2-enums';

@Component({
    selector: 'fi-task-list-item',
    templateUrl: './task-list-item.component.html',
    styleUrls: ['./task-list-item.component.scss', './task-item-shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-list-item' },
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class TaskListItemComponent implements OnInit, OnDestroy {
    @Input() task: ITask;

    ProfileSizes = FiProfileSizes;

    constructor(
        private appTextService: AppTextService,
        private taskSharedService: FiTaskSharedService,
        private taskHelperService: FiTaskHelperService,
        private userDataService: FiUserDataService,
        private cdr: ChangeDetectorRef,
        private fiStateService: FiStateService,
        private detectDevices: DetectDevicesService,
    ) {}

    ngOnInit(): void {
        this.taskHelperService.taskCompletedChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(($event) => {
            if (this.task.Id === $event.taskId) {
                this.task.IsCompleted = $event.isCompleted;
                this.cdr.markForCheck();
            }
        });
    }
    onCompletedClick() {
        this.taskSharedService.saveTaskCompleted(
            [this.task],
            this.task.IsCompleted,
            () => {
                this.cdr.markForCheck();
                this.taskHelperService.taskCompletedChanged$.next({
                    taskId: this.task.Id,
                    isCompleted: this.task.IsCompleted,
                });
            },
            () => {
                this.task.IsCompleted = !this.task.IsCompleted;
                this.cdr.markForCheck();
            },
            true,
        );
    }

    onTaskItemClick($event: MouseEvent) {
        if (this.detectDevices.isMobilePhone()) {
            this.openTaskDetails($event);
        }
    }

    getTaskClass() {
        return this.taskHelperService.getTaskClass(this.task);
    }
    getDeadlineText() {
        return this.taskHelperService.getDeadlineText(this.task);
    }
    getCommentsText() {
        return this.taskHelperService.getCommentsText(this.task);
    }
    /*getAssigneesText() {
        return this.taskHelperService.getAssigneesText(this.task);
    }*/

    onTaskDeadlineClick($event: MouseEvent) {
        if (!!this.task.Deadline) {
            this.openTaskDetails($event);
        }
    }

    onTaskCommentsClick($event: MouseEvent) {
        if (!!this.task.CommentsCount) {
            this.openTaskDetails($event);
        }
    }

    openTaskDetails($event: MouseEvent) {
        $event.stopPropagation();
        this.fiStateService.go(FiStateNames.Task.Details, {
            id: this.task.Id,
        });
    }

    protected get isAutomatedTask(): boolean {
        return this.taskHelperService.isAutomatedTask(this.task.TaskType);
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
